import { call, put, takeLatest } from 'redux-saga/effects';

import { InsurancePolicyUserApi } from '@apis/InsurancePolicyUserApi';
import { InsurancePolicyUser } from '@models/InsurancePolicyUser';
import { SagaPayload } from '@utils/typescript';

import {
  insurancePolicyUserFetch,
  InsurancePolicyUserFetchPayload,
  insurancePolicyUserHealthPolicyBenefitLimitsFetch,
  InsurancePolicyUserHealthPolicyBenefitLimitsFetchPayload,
  stateUpdate,
  StateUpdatePayload,
} from './action';
import { PolicyBenefitLimit } from '@models/PolicyBenefitLimit';

function* handleInsurancePolicyUserFetch({ payload }: SagaPayload<InsurancePolicyUserFetchPayload>) {
  const state: StateUpdatePayload = { policyUser: null };
  try {
    state.policyUser = (yield call(InsurancePolicyUserApi.get, payload)) as InsurancePolicyUser;
    yield put(stateUpdate(state));
  } catch {
    yield put(stateUpdate(state));
  }
}

function* handleInsurancePolicyUserHealthPolicyBenefitLimitsFetch({ payload }: SagaPayload<InsurancePolicyUserHealthPolicyBenefitLimitsFetchPayload>) {
  const state: StateUpdatePayload = { healthPolicyBenefitLimitsWithAccumulatedPaidAmounts: null };
  try {
    state.healthPolicyBenefitLimitsWithAccumulatedPaidAmounts = (yield call(InsurancePolicyUserApi.getHealthPolicyBenefitLimitsWithAccumulatedPaidAmounts, payload)) as PolicyBenefitLimit[];
    yield put(stateUpdate(state));
  } catch {
    yield put(stateUpdate(state));
  }
}

export default function* () {
  yield takeLatest(insurancePolicyUserFetch, handleInsurancePolicyUserFetch);
  yield takeLatest(insurancePolicyUserHealthPolicyBenefitLimitsFetch, handleInsurancePolicyUserHealthPolicyBenefitLimitsFetch);
}
